import SubpageLink from './SubpageLink';

export default SubpageLink;
